
import { Injectable } from '@angular/core';
import { Picture } from 'compob2b-libs';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AvatarImageDataService {
  private avatarPicture: BehaviorSubject<Picture> = new BehaviorSubject<any>(null);

  setData(picture: Picture) {
    this.avatarPicture.next(picture);
  }

  getData() {
    return this.avatarPicture.asObservable();
  }
}
